export default __webpack_public_path__ + "static/media/times.73c63c1f.svg";